import { graphqlFetch } from '@pylot-data/graphqlFetch'
import type { CustomerInput, CustomerOutput } from '@pylot-data/fwrdschema'
import { CREATE_CUSTOMER } from './graphql/createCustomerCheckout'
import { useLogin, useAuthUI } from '@corratech/pylot-auth-manager'
import { useRouter } from 'next/router'

export type CreateCustomerResponse = {
    data: { createCustomer: CustomerOutput }
}

export const useCreateAccountOnCheckout = () => {
    const { login } = useLogin()
    const { locale } = useRouter()
    const { signUpCallbacks, clearAuthCallback } = useAuthUI()

    return {
        createAccountOnCheckout: async (
            params: CustomerInput,
            orderId: string
        ) => {
            const createResult = await graphqlFetch<
                {
                    input: CustomerInput
                    increment_id: string
                },
                CreateCustomerResponse
            >({
                query: CREATE_CUSTOMER,
                variables: { input: params, increment_id: orderId },
                locale
            })
            if (createResult.errors) throw createResult.errors
            await login({
                email: params.email!,
                password: params.password!
            })
            if (signUpCallbacks.length) {
                signUpCallbacks.forEach((callback) => {
                    if (typeof callback === 'function') {
                        callback()
                    }
                })
                clearAuthCallback('SIGNUP_VIEW')
            }
            return { createResult }
        }
    }
}
